import { NOTIFICATIONS } from "consts/notifications";
import { fixedDigitsValue } from "helpers/dataHelpers";
import { CheckCircleIcon, CurrencyIcon } from "icons";
import { FlexContainer } from "styled/Box";
import { LoyaltyBonus } from "types/loyalty";

export enum LoyaltyTiersField {
  IsLoyaltyFeatureEnabled = "isLoyaltyFeatureEnabled",
}

export type ConfirmModalType = {
  key: LoyaltyTiersField;
  value: boolean;
};

export const notificationMessage = {
  [LoyaltyTiersField.IsLoyaltyFeatureEnabled]:
    NOTIFICATIONS.IS_APP_CONFIG_UPDATED,
};

export const columns = [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Discounts (%)",
    dataIndex: "discountPercentage",
    key: "discountPercentage",
    align: "right" as const,
  },
  {
    title: "Free days",
    dataIndex: "freeDeliveryDays",
    key: "freeDeliveryDays",
    align: "right" as const,
  },
  {
    title: "Birthday bonus (FM Coins)",
    dataIndex: "birthdayGift",
    key: "birthdayGift",
    align: "center" as const,
    render: (value: number) => (
      <FlexContainer $align="center" $justify="center" $gap={8}>
        {fixedDigitsValue(Number(value), 3)} <CurrencyIcon />
      </FlexContainer>
    ),
  },
  {
    title: "Welcome bonus (FM Coins)",
    dataIndex: "welcomeBonus",
    key: "welcomeBonus",
    align: "center" as const,
    render: (value: number) => (
      <FlexContainer $align="center" $justify="center" $gap={8}>
        {fixedDigitsValue(Number(value), 3)} <CurrencyIcon />
      </FlexContainer>
    ),
  },
  {
    title: "Healthy perk",
    dataIndex: "healthyPerkAvailable",
    key: "healthyPerkAvailable",
    align: "center" as const,
    render: (vipCategoryAvailable: boolean) =>
      vipCategoryAvailable ? <CheckCircleIcon /> : null,
  },
  {
    title: "Vip category",
    dataIndex: "vipCategoryAvailable",
    key: "vipCategoryAvailable",
    align: "center" as const,
    render: (vipCategoryAvailable: boolean) =>
      vipCategoryAvailable ? <CheckCircleIcon /> : null,
  },
  {
    title: "AI features",
    dataIndex: "aiAssistantAvailable",
    key: "aiAssistantAvailable",
    align: "center" as const,
    render: (aiAssistantAvailable: boolean) =>
      aiAssistantAvailable ? <CheckCircleIcon /> : null,
  },
  {
    title: "Free items",
    dataIndex: "bonus",
    key: "bonus",
    align: "right" as const,
    render: (bonus: LoyaltyBonus) => bonus?.title || "",
  },
];
